/**
 * Shared corner-radius for every article card-structure container.
 *
 * Responsive ladder, built from DS radius tokens:
 *   mobile (base) → --radius-3xl (16px)
 *   tablet (md)   → --radius-4xl (20px)
 *   desktop (lg)  → --radius-5xl (24px)
 *
 * The trailing `!` (Tailwind v4 important) is required to override the DS
 * `.acko-card` default radius (--radius-4xl). It is harmless on raw-div
 * containers that have no competing radius rule.
 *
 * Apply to outer card surfaces only — not to avatars, buttons, icon chips
 * or media frames, which carry their own intentional radii.
 */
export const CARD_RADIUS =
  '[border-radius:var(--radius-3xl)]! md:[border-radius:var(--radius-4xl)]! lg:[border-radius:var(--radius-5xl)]!'

/*
 * Note: the DS table's rounded frame lives on its internal
 * `.acko-table-wrapper` div, which can't be reached via the <Table>
 * className. Its responsive radius is handled with scoped media queries in
 * src/app/new-blogs/layout.css (Tailwind would not generate a responsive
 * arbitrary descendant-class variant for it).
 */
